import request from '@/utils/request'

export function show(id) {
  return request({
    url: `/settings/${id}`,
    method: 'get',
  })
}
